<script>
export default {
  props: {
    title: {
      type: String,
      required: true,
    },
    src: {
      type: String,
      required: true,
    },
  },
};
</script>

<template>
  <div class="flex flex-col items-center">
    <button
      class="bg-n-gray-50 dark:bg-n-vars-black-br/30 cursor-pointer flex flex-col justify-center transition-all duration-200 ease-in -m-px py-4 px-0 items-center border border-solid border-n-gray-1 dark:border-n-vars-black-bd/80 hover:border-grass-500 dark:hover:border-grass-500 hover:shadow-md hover:z-50 disabled:opacity-60 h-32"
    >
      <img :src="src" :alt="title" class="w-1/2 my-4 mx-auto" />
    </button>
    <h3
      class="mt-2 text-n-gray-5 text-xs text-center capitalize"
    >
      {{ title }}
    </h3>
  </div>
</template>

<style scoped lang="scss">
.inactive {
  img {
    filter: grayscale(100%);
  }

  &:hover {
    @apply border-transparent shadow-none cursor-not-allowed;
  }
}
</style>
